export default __webpack_public_path__ + "static/media/56g.7f1462ea.svg";